import { styled } from 'next-yak';

// *** Components ***
export const ThemeModeSwitcher = styled.div``;
